<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex enfinty-header flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <ng-container *ngIf="!isScreenSmall">
            <!-- Logo -->
            <div class="flex items-center mx-2 lg:mr-8">
                <div class="hidden lg:flex" (click)="Onimage()">
                    <img class="dark:hidden w-24" src="assets/images/logo/PE.png" />
                    <img class="hidden dark:flex w-24" src="assets/images/logo/PE.png" />
                </div>
                <!-- <img
                    class="flex lg:hidden w-8"
                    src="assets/images/logo/logo.svg"
                /> -->
            </div>
        </ng-container>
        <!-- Navigation toggle button -->
        <ng-container>
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </ng-container>
        <!-- Components -->
        <div class="text-center  justify-center flex flex-1 text-3xl">
            <h3 class="fs-40 text-primary font-500 font-medium">Aquapaas</h3>
        </div>

        <div class="flex items-center pl-2 ml-auto ">

            <!--
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications> -->
            <button class="ml-4 hover:bg-magenta font-medium rounded-full mr-2 text-white bg-primary font-500 text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base" mat-flat-button type="submit" [color]="'bg-primary     '"
                (click)="partnerdetail(user.id)">{{partnerName}}
            </button>
            <user class="user-dropdown"></user>
            <!-- <button class="ml-4" mat-flat-button type="submit" [color]="'primary'"(click)="partnerdetail(user.partner_id)">{{user.partnerName}}
            </button> -->
            <div class="hs-dropdown relative inline-flex">
                <!-- <button mat-icon-button [matMenuTriggerFor]="userActions">
                    <span class="relative">
                        <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user?.profile_image_name"
                            [src]="user?.profile_image_name">
                        <mat-icon *ngIf="!showAvatar || !user?.profile_image_name"
                            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user?.profile_image_name,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"></span>
                    </span>
                </button> -->
                <!-- 
                <mat-menu [xPosition]="'before'" #userActions="matMenu">
                    <button mat-menu-item (click)="userdetail(user.id)">
                        <span class="flex flex-col leading-none">
                            <span>Signed in as</span>
                            <span class="mt-1.5 text-md font-medium">{{user?.userName}}</span>
                        </span>
                    </button>

                    <button mat-menu-item (click)=" changepassword()">
                        <mat-icon>vpn_key</mat-icon>
                        <span>Change Password</span>
                    </button>

                    <mat-divider class="my-2"></mat-divider>
                    <button mat-menu-item (click)="signOut()">
                        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
                        <span>Sign out</span>
                    </button>
                </mat-menu> -->

                <div class="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-60 bg-white shadow-md rounded-lg p-2 mt-2 dark:bg-neutral-800 dark:border dark:border-neutral-700"
                    aria-labelledby="hs-dropdown-custom-trigger">
                    <a class="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700"
                        href="#">
                        Newsletter
                    </a>
                    <a class="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700"
                        href="#">
                        Purchases
                    </a>
                    <a class="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700"
                        href="#">
                        Downloads
                    </a>
                    <a class="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-300 dark:focus:bg-neutral-700"
                        href="#">
                        Team Account
                    </a>
                </div>
            </div>


        </div>
    </div>
    <div class="flex flex-row flex-automt-4 ml-4 mr-4 mt-4">
        <!-- Navigation -->
        <!-- <fuse-vertical-navigation
            class="bg-card dark:bg-gray-900 print:hidden"
            [mode]="isScreenSmall ? 'over' : 'side'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="!isScreenSmall"
        >
        </fuse-vertical-navigation> -->

        <!-- Navigation -->
        <fuse-vertical-navigation
            class="bg-card dark:bg-gray-900 print:hidden mb-2"
            [appearance]="'enfinity'"
            [mode]="isScreenSmall ? 'over' : 'side'"
            [name]="'mainNavigation'"
            [navigation]="navigation"
            [opened]="!isScreenSmall"
        >
        
        </fuse-vertical-navigation>

        <!-- Content -->
        <div class="flex flex-auto w-full  scroll-hidde">
        <div class="flex flex-auto w-full  ">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>

    <!-- Footer -->

   
</div>

<div class="relative bg-card text-center justify-center flex flex-1 text-3xl print:hidden pt-3 pb-3">
    <span class="font-500 text-lg font-medium text-primary flex  "> <span class=" mt-2 mr-2"> Powered by </span>
        <img src="https://energy.enfiniti.net/assets/img/enfiniti-dark.png" class="h-12 w-auto"> </span>
</div>